import { CSVLink } from "react-csv";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

import { crossSellFrequentRecommendationData } from "../../services/interfaces/ICrossSellOpportunity";
import { numberFormatter } from "../../utils/formatter";
import { Checkbox } from "rsuite";
import { useEffect, useState } from "react";

const FrequentlyBoughtTable = ({
  crossellSKULevelDataCopy,
  updateSKULevelData,
  selectedItemID,
  updateSaveButton,
  selectedCustomerId,
  selectedPeerName,
  selectedItem,
  updateSKUData,
}: any) => {
  const removeLeadingZero = (n: any) => {
    let newStr = n?.replace(/^0+/, "");
    return newStr;
  };

  const [selectedUpdateData, setSelectedUpdateData] = useState<
    Array<string | null>
  >([]);

  useEffect(() => {
    setSelectedUpdateData(updateSKUData);
  }, [updateSKUData]);

  const handleCheckboxSelection = (data: any) => {
    updateSaveButton(true);
    let finalData = JSON.parse(JSON.stringify(selectedUpdateData));
    let index = finalData?.findIndex((val: any) => val?.sku2 === data?.sku2);
    if (index !== -1) {
      finalData[index].accept_ind = data?.accept_ind === 1 ? 0 : 1;
      finalData[index].marked = false;
    } else {
      let obj = {
        accept_ind: data?.accept_ind === 1 ? 0 : 1,
        customer: selectedCustomerId,
        itemid: selectedItem,
        peerGroupName: selectedPeerName,
        sku2: data?.sku2,
        marked: false,
      };
      finalData.push(obj);
    }
    updateSKULevelData(finalData);
  };

  return (
    <div className="h-full w-full">
      <div className="business-cost-trend-table mt-[0]">
        <DataTable
          className="h-full w-full"
          value={
            crossellSKULevelDataCopy && selectedItemID
              ? crossellSKULevelDataCopy
              : []
          }
          stripedRows
          scrollable
          scrollHeight="61vh"
          showGridlines
          emptyMessage="No Data Found"
        >

          <Column
            field="sku2_l3"
            header="Category"
            body={(rowdata: crossSellFrequentRecommendationData) => {
              return (
                <div className="flex justify-start items-center">
                  <span>{rowdata.sku2_l3}</span>
                </div>
              );
            }}
          ></Column>

          <Column
            field="sku2"
            header="Item ID"
            body={(rowdata: crossSellFrequentRecommendationData) => {
              return (
                <div className="flex-col justify-start items-center">
                  {rowdata?.SKU2_ImageLink !== 'NA' && rowdata?.SKU2_ImageLink &&  <img
                    src={rowdata.SKU2_ImageLink}
                    alt="item-logo"
                    className="w-[7vh] h-[6vh] mb-[.5vh]"
                  />}
                  <span>{removeLeadingZero(rowdata.sku2)}</span>
                </div>
              );
            }}
          ></Column>

          <Column
            field="SKU2_Master_Vendor_Name"
            header="Supplier"
            body={(rowdata: crossSellFrequentRecommendationData) => {
              return (
                <div className="flex justify-start items-center">
                  <span>{rowdata.SKU2_Master_Vendor_Name}</span>
                </div>
              );
            }}
          ></Column>



          <Column
            field="SKU2_Desc"
            header="Item Desc"
            body={(rowdata: crossSellFrequentRecommendationData) => {
              return (
                <div className="flex justify-start items-center">
                  <span>{rowdata.SKU2_Desc}</span>
                </div>
              );
            }}
          ></Column>

          <Column
            field="qty"
            header="Qty"
            body={(rowdata: crossSellFrequentRecommendationData) => {
              return (
                <div className="flex justify-start items-center">
                  <span>{numberFormatter(rowdata.qty, 0)}</span>
                </div>
              );
            }}
          ></Column>

          <Column
            field="accept_ind"
            header="Accept"
            body={(rowdata: crossSellFrequentRecommendationData) => {
              return (
                <div className="flex justify-start items-center">
                  <span>
                    <Checkbox
                      key={rowdata?.sku2}
                      defaultChecked={rowdata?.accept_ind === 1 ? true : false}
                      value={rowdata?.accept_ind}
                      color="green"
                      onChange={(value: any) => {
                        handleCheckboxSelection(rowdata);
                      }}
                    ></Checkbox>
                  </span>
                </div>
              );
            }}
          ></Column>
        </DataTable>
      </div>
    </div>
  );
};

export default FrequentlyBoughtTable;
